import { render, staticRenderFns } from "./template6.vue?vue&type=template&id=4417f63a&scoped=true"
import script from "./template6.vue?vue&type=script&lang=js"
export * from "./template6.vue?vue&type=script&lang=js"
import style0 from "./template6.vue?vue&type=style&index=0&id=4417f63a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4417f63a",
  null
  
)

export default component.exports